import LegalLayout, { Section, Bullets } from "@/components/legal/LegalLayout";
import { useSeo } from "@/lib/seo";

export default function PrivacyPolicy() {
  useSeo({
    title: "Privacy Policy – QuickDukaan",
    description: "Read how QuickDukaan collects, uses and protects your personal information when you shop or sell on the platform.",
    path: "/privacy-policy",
  });

  return (
    <LegalLayout
      testid="privacy-policy-page"
      title="Privacy Policy"
      intro={
        <>
          Welcome to QuickDukaan (<strong>“Platform”, “we”, “our”, “us”</strong>). Your privacy is important to us. This Privacy Policy
          explains how QuickDukaan collects, uses, stores, and protects your information when you use QuickDukaan.
        </>
      }
      crumbs={[{ label: "Privacy Policy" }]}
      lastUpdated="21 May 2026"
    >
      <p>By using the Platform, you agree to the practices described in this Privacy Policy.</p>

      <Section number={1} title="Information We Collect">
        <Bullets items={["Name", "Mobile number", "Delivery address", "Email address (if provided)"]} />
      </Section>

      <Section number={2} title="Order Information">
        <Bullets items={["Products ordered", "Store selected", "Order history", "Delivery preferences"]} />
      </Section>

      <Section number={3} title="Technical Information">
        <Bullets items={["Device type", "Browser type", "IP address", "App or website usage information"]} />
      </Section>

      <Section number={4} title="How We Use Your Information">
        <Bullets items={[
          "Create and manage your account",
          "Process and deliver orders",
          "Improve customer experience",
          "Provide support",
          "Prevent fraud and misuse",
          "Communicate order updates",
        ]} />
      </Section>

      <Section number={5} title="OTP Verification">
        <p>
          QuickDukaan uses mobile OTP verification for login and authentication purposes. By using the Platform, users
          consent to receiving OTP-related SMS communications.
        </p>
      </Section>

      <Section number={6} title="Data Sharing">
        <p>We may share limited information with:</p>
        <Bullets items={[
          "Sellers/store owners for fulfilling orders",
          "Delivery personnel for delivery purposes",
          "Technology and hosting service providers",
        ]} />
        <p><strong>We do not sell personal information to third parties.</strong></p>
      </Section>

      <Section number={7} title="Data Security">
        <p>We take reasonable measures to protect user data. However, no online platform can guarantee 100% security.</p>
      </Section>

      <Section number={8} title="Cookies & Analytics">
        <p>We may use cookies and analytics tools to improve platform performance and user experience.</p>
      </Section>

      <Section number={9} title="User Responsibilities">
        <p>Users must:</p>
        <Bullets items={[
          "Provide accurate information",
          "Use the Platform lawfully",
          "Not misuse or attempt fraudulent activity",
        ]} />
      </Section>

      <Section number={10} title="Changes to This Policy">
        <p>We may update this Privacy Policy from time to time without prior notice.</p>
      </Section>

      <Section number={11} title="Contact Us">
        <p>
          Email: <a href="mailto:support@quickdukaan.in">support@quickdukaan.in</a>
        </p>
      </Section>
    </LegalLayout>
  );
}
